package org.example.project

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ExitToApp
import androidx.compose.material.icons.filled.CheckCircle
import androidx.compose.material.icons.filled.Face
import androidx.compose.material.icons.filled.Favorite
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.Refresh
import androidx.compose.material.icons.filled.Settings
import androidx.compose.material.icons.filled.Share
import androidx.compose.material.icons.filled.Star
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.LinearProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import kotlinx.coroutines.delay
import org.jetbrains.compose.resources.painterResource
import plush_morph_partner.composeapp.generated.resources.Res
import plush_morph_partner.composeapp.generated.resources.app_icon
import plush_morph_partner.composeapp.generated.resources.app_qr_code
import plush_morph_partner.composeapp.generated.resources.app_store_badge
import plush_morph_partner.composeapp.generated.resources.demo_plushie
import plush_morph_partner.composeapp.generated.resources.demo_result
import plush_morph_partner.composeapp.generated.resources.demo_user
import plush_morph_partner.composeapp.generated.resources.hero_iphone_0
import plush_morph_partner.composeapp.generated.resources.hero_iphone_1
import androidx.compose.ui.platform.LocalUriHandler

// Vercel-inspired Theme Colors
val BgWhite = Color.White
val BgGray = Color(0xFFFAFAFA)
val BorderColor = Color(0xFFEAEAEA)
val TextPrimary = Color.Black
val TextSecondary = Color(0xFF666666)
val AccentBlack = Color.Black
val AccentPink = Color(0xFFEB367E)

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun Header(
    isLoggedIn: Boolean = false,
    userEmail: String? = null,
    onLoginClick: () -> Unit = {},
    onLogoutClick: () -> Unit = {},
    onSettingsClick: () -> Unit = {}
) {
    val uriHandler = LocalUriHandler.current
    Column {
        TopAppBar(
            title = {
                Row(
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Image(
                        painter = painterResource(Res.drawable.app_icon),
                        contentDescription = "PlushMorph Logo",
                        modifier = Modifier.size(28.dp).clip(RoundedCornerShape(6.dp)),
                    )
                    Spacer(modifier = Modifier.width(10.dp))
                    Text(
                        "PlushMorph",
                        fontWeight = FontWeight.Bold,
                        color = TextPrimary,
                        fontSize = 18.sp,
                        letterSpacing = (-0.5).sp
                    )
                }
            },
            actions = {
            if (isLoggedIn) {
                var showMenu by remember { mutableStateOf(false) }
                val avatarText = userEmail?.take(2)?.uppercase() ?: "JD"

                Box {
                    // User Avatar with click to toggle menu
                    Box(
                        modifier = Modifier
                            .size(36.dp)
                            .clip(RoundedCornerShape(50))
                            .background(AccentColor)
                            .clickable { showMenu = true },
                        contentAlignment = Alignment.Center
                    ) {
                        Text(avatarText, color = Color.White, fontWeight = FontWeight.Bold)
                    }

                    DropdownMenu(
                        expanded = showMenu,
                        onDismissRequest = { showMenu = false },
                        modifier = Modifier.background(Color.White)
                    ) {
                        if (userEmail != null) {
                            DropdownMenuItem(
                                text = {
                                    Column {
                                        Text(
                                            "Signed in as",
                                            style = MaterialTheme.typography.labelSmall,
                                            color = Color.Gray
                                        )
                                        Text(
                                            userEmail,
                                            fontWeight = FontWeight.Bold,
                                            style = MaterialTheme.typography.bodyMedium
                                        )
                                    }
                                },
                                onClick = {},
                                enabled = false // Make it non-clickable effectively acting as a header
                            )
                            HorizontalDivider()
                        }

                        DropdownMenuItem(
                            text = { Text("Settings") },
                            onClick = {
                                showMenu = false
                                onSettingsClick()
                            },
                            leadingIcon = { Icon(Icons.Default.Settings, contentDescription = null) }
                        )

                        DropdownMenuItem(
                            text = { Text("Log Out") },
                            onClick = {
                                showMenu = false
                                onLogoutClick()
                            },
                            leadingIcon = { Icon(Icons.AutoMirrored.Filled.ExitToApp, contentDescription = null) }
                        )
                    }
                }
                Spacer(modifier = Modifier.width(16.dp))
            } else {
                Button(
                    onClick = onLoginClick,
                    colors = ButtonDefaults.buttonColors(containerColor = PrimaryColor),
                    contentPadding = PaddingValues(horizontal = 20.dp)
                ) {
                    Text("Get Started")
                }
                Spacer(modifier = Modifier.width(16.dp))
            }
        },
            colors = TopAppBarDefaults.topAppBarColors(
                containerColor = BgWhite
            )
        )
        HorizontalDivider(color = BorderColor)
    }
}

@Composable
fun HeroSection(isMobile: Boolean) {
    val uriHandler = LocalUriHandler.current

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(vertical = if (isMobile) 60.dp else 120.dp, horizontal = 24.dp),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        //Text(
        //    "Pretty Private",
        //    style = if (isMobile) MaterialTheme.typography.displayMedium else MaterialTheme.typography.displayLarge,
        //    fontWeight = FontWeight.ExtraBold,
        //    textAlign = TextAlign.Center,
        //    color = TextPrimary,
        //    lineHeight = if (isMobile) 48.sp else 72.sp,
        //    letterSpacing = (-2).sp
        //)
        //Spacer(modifier = Modifier.height(24.dp))
        //Text(
        //    "Ghost the algorithm.\nStay adorable.",
        //    style = if (isMobile) MaterialTheme.typography.titleMedium else MaterialTheme.typography.titleLarge,
        //    textAlign = TextAlign.Center,
        //    color = TextSecondary,
        //    modifier = Modifier.widthIn(max = 700.dp),
        //    lineHeight = if (isMobile) 24.sp else 32.sp
        //)
        Text(
            "Pretty Private",
            style = if (isMobile) MaterialTheme.typography.displayMedium else MaterialTheme.typography.displayLarge,
            fontWeight = FontWeight.Black, // 甚至可以用 Black 更有力量感
            textAlign = TextAlign.Center,
            color = TextPrimary,
            lineHeight = if (isMobile) 48.sp else 72.sp,
            letterSpacing = (-3).sp // 再紧一点，更有整体感
        )

        Spacer(modifier = Modifier.height(if (isMobile) 16.dp else 24.dp))

        // 这一部分是精髓
        Text(
            text = "Ghost the algorithm.",
            style = if (isMobile) MaterialTheme.typography.headlineSmall else MaterialTheme.typography.headlineMedium,
            fontWeight = FontWeight.Light, // 用细体，制造“幽灵”感
            color = TextPrimary.copy(alpha = 0.7f),
            textAlign = TextAlign.Center
        )

        Text(
            text = "Stay adorable.",
            style = if (isMobile) MaterialTheme.typography.headlineSmall else MaterialTheme.typography.headlineMedium,
            fontWeight = FontWeight.Medium, // 稍微重一点点，显得坚定
            fontStyle = FontStyle.Italic, // 斜体，增加那种“吹烟”的俏皮感
            color = TextPrimary, // 颜色回正，强调这个才是结果
            textAlign = TextAlign.Center
        )

        Spacer(modifier = Modifier.height(48.dp))

        // App Store and QR Code Row
        if (isMobile) {
            Image(
                painter = painterResource(Res.drawable.app_store_badge),
                contentDescription = "Download on the App Store",
                modifier = Modifier
                    .height(60.dp)
                    .clickable { uriHandler.openUri("https://apps.apple.com/app/id6757099255") }
            )
        } else {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center,
                modifier = Modifier.fillMaxWidth()
            ) {
                Image(
                    painter = painterResource(Res.drawable.app_store_badge),
                    contentDescription = "Download on the App Store",
                    modifier = Modifier
                        .height(60.dp)
                        .clickable { uriHandler.openUri("https://apps.apple.com/app/id6757099255") }
                )
                Spacer(modifier = Modifier.width(32.dp))
                Column(horizontalAlignment = Alignment.CenterHorizontally) {
                    Image(
                        painter = painterResource(Res.drawable.app_qr_code),
                        contentDescription = "Scan to download",
                        modifier = Modifier.size(96.dp)
                    )
                    Spacer(modifier = Modifier.height(4.dp))
                    Text("Scan to download", fontSize = 12.sp, color = TextSecondary)
                }
            }
        }

        Spacer(modifier = Modifier.height(if (isMobile) 60.dp else 100.dp))

        // Hero Mockups
        if (isMobile) {
            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
                modifier = Modifier.fillMaxWidth()
            ) {
                Image(
                    painter = painterResource(Res.drawable.hero_iphone_0),
                    contentDescription = "App Interface Before",
                    modifier = Modifier.height(400.dp)
                )
                Spacer(modifier = Modifier.height(32.dp))
                Image(
                    painter = painterResource(Res.drawable.hero_iphone_1),
                    contentDescription = "App Interface After",
                    modifier = Modifier.height(400.dp)
                )
            }
        } else {
            Row(
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier.fillMaxWidth()
            ) {
                Image(
                    painter = painterResource(Res.drawable.hero_iphone_0),
                    contentDescription = "App Interface Before",
                    modifier = Modifier.height(550.dp)
                )
                Spacer(modifier = Modifier.width(64.dp))
                Image(
                    painter = painterResource(Res.drawable.hero_iphone_1),
                    contentDescription = "App Interface After",
                    modifier = Modifier.height(550.dp)
                )
            }
        }
    }
}

@Composable
fun DemoSection(isMobile: Boolean) {
    var isProcessing by remember { mutableStateOf(false) }
    var isSuccess by remember { mutableStateOf(false) }
    var progress by remember { mutableStateOf(0f) }

    LaunchedEffect(isProcessing) {
        if (isProcessing) {
            val steps = 100
            for (i in 1..steps) {
                progress = i / 100f
                delay(20)
            }
            isProcessing = false
            isSuccess = true
        }
    }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .background(BgGray)
            .padding(horizontal = 24.dp, vertical = if (isMobile) 60.dp else 100.dp),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Column(
            modifier = Modifier
                .widthIn(max = 900.dp)
                .background(BgWhite, shape = RoundedCornerShape(12.dp))
                .border(1.dp, BorderColor, RoundedCornerShape(12.dp))
                .padding(if (isMobile) 32.dp else 64.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Text(
                "Interactive Morphing Engine",
                style = if (isMobile) MaterialTheme.typography.titleLarge else MaterialTheme.typography.headlineMedium,
                fontWeight = FontWeight.Bold,
                color = TextPrimary,
                modifier = Modifier.padding(bottom = 12.dp),
                textAlign = TextAlign.Center
            )
            Text(
                "See how the AI maps human features to plushie topology.",
                color = TextSecondary,
                modifier = Modifier.padding(bottom = if (isMobile) 32.dp else 56.dp),
                textAlign = TextAlign.Center
            )

            if (!isSuccess) {
                if (isMobile) {
                    Column(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        Image(
                            painter = painterResource(Res.drawable.demo_user),
                            contentDescription = "User Photo",
                            modifier = Modifier
                                .size(150.dp)
                                .clip(RoundedCornerShape(8.dp))
                                .border(1.dp, BorderColor, RoundedCornerShape(8.dp))
                        )
                        Box(modifier = Modifier.size(2.dp, 32.dp).background(BorderColor))
                        Image(
                            painter = painterResource(Res.drawable.demo_plushie),
                            contentDescription = "Plushie Style",
                            modifier = Modifier
                                .size(150.dp)
                                .clip(RoundedCornerShape(8.dp))
                                .border(1.dp, BorderColor, RoundedCornerShape(8.dp))
                        )
                    }
                } else {
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.SpaceEvenly,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Image(
                            painter = painterResource(Res.drawable.demo_user),
                            contentDescription = "User Photo",
                            modifier = Modifier
                                .size(200.dp)
                                .clip(RoundedCornerShape(8.dp))
                                .border(1.dp, BorderColor, RoundedCornerShape(8.dp))
                        )
                        Box(modifier = Modifier.size(1.dp, 100.dp).background(BorderColor))
                        Image(
                            painter = painterResource(Res.drawable.demo_plushie),
                            contentDescription = "Plushie Style",
                            modifier = Modifier
                                .size(200.dp)
                                .clip(RoundedCornerShape(8.dp))
                                .border(1.dp, BorderColor, RoundedCornerShape(8.dp))
                        )
                    }
                }

                Spacer(modifier = Modifier.height(if (isMobile) 32.dp else 56.dp))

                if (isProcessing) {
                    Column(horizontalAlignment = Alignment.CenterHorizontally, modifier = Modifier.fillMaxWidth(if (isMobile) 1f else 0.6f)) {
                        LinearProgressIndicator(
                            progress = { progress },
                            modifier = Modifier.fillMaxWidth().height(6.dp).clip(RoundedCornerShape(3.dp)),
                            color = AccentBlack,
                            trackColor = BorderColor,
                        )
                        Spacer(modifier = Modifier.height(16.dp))
                        Text("Synthesizing neural plushie layers... ${(progress * 100).toInt()}%", color = TextPrimary, fontWeight = FontWeight.Medium, fontSize = 14.sp)
                    }
                } else {
                    Button(
                        onClick = { isProcessing = true },
                        colors = ButtonDefaults.buttonColors(
                            containerColor = AccentBlack,
                            disabledContainerColor = BorderColor
                        ),
                        modifier = Modifier
                            .fillMaxWidth(if (isMobile) 1f else 0.5f)
                            .height(52.dp),
                        shape = RoundedCornerShape(6.dp)
                    ) {
                        Text("Melt Together", fontSize = 16.sp, fontWeight = FontWeight.Bold)
                    }
                }
            } else {
                Column(horizontalAlignment = Alignment.CenterHorizontally) {
                    Image(
                        painter = painterResource(Res.drawable.demo_result),
                        contentDescription = "Result Image",
                        modifier = Modifier
                            .size(if (isMobile) 220.dp else 280.dp)
                            .clip(RoundedCornerShape(8.dp))
                            .border(1.dp, BorderColor, RoundedCornerShape(8.dp))
                    )

                    Spacer(modifier = Modifier.height(40.dp))
                    Button(
                        onClick = {
                            isSuccess = false
                            progress = 0f
                        },
                        colors = ButtonDefaults.buttonColors(containerColor = BgWhite),
                        modifier = Modifier.height(44.dp).border(1.dp, BorderColor, RoundedCornerShape(6.dp)),
                        shape = RoundedCornerShape(6.dp)
                    ) {
                        Icon(Icons.Default.Refresh, contentDescription = null, modifier = Modifier.size(16.dp), tint = TextPrimary)
                        Spacer(modifier = Modifier.width(8.dp))
                        Text("Reset Demo", color = TextPrimary)
                    }
                }
            }
        }
    }
}

@Composable
fun UploadBox(label: String, icon: ImageVector, isSelected: Boolean, onClick: () -> Unit) {
    Box(
        modifier = Modifier
            .size(200.dp)
            .clip(RoundedCornerShape(8.dp))
            .background(if (isSelected) BgGray else BgWhite)
            .border(
                width = 1.dp,
                color = if (isSelected) AccentBlack else BorderColor,
                shape = RoundedCornerShape(8.dp)
            )
            .clickable { onClick() },
        contentAlignment = Alignment.Center
    ) {
        Column(horizontalAlignment = Alignment.CenterHorizontally) {
            Icon(
                if (isSelected) Icons.Default.CheckCircle else icon,
                contentDescription = null,
                tint = if (isSelected) AccentBlack else TextSecondary.copy(alpha = 0.3f),
                modifier = Modifier.size(40.dp)
            )
            Spacer(modifier = Modifier.height(16.dp))
            Text(label, color = if (isSelected) TextPrimary else TextSecondary, fontWeight = FontWeight.SemiBold, fontSize = 14.sp)
        }
    }
}

@Composable
fun FeaturesSection(isMobile: Boolean) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(vertical = if (isMobile) 60.dp else 120.dp, horizontal = 24.dp),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Text(
            "Precision Generation.",
            style = if (isMobile) MaterialTheme.typography.headlineMedium else MaterialTheme.typography.headlineLarge,
            fontWeight = FontWeight.Bold,
            color = TextPrimary,
            letterSpacing = (-1).sp
        )
        Spacer(modifier = Modifier.height(64.dp))

        if (isMobile) {
            Column(
                modifier = Modifier.fillMaxWidth(),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(48.dp)
            ) {
                FeatureItem(
                    icon = Icons.Default.Face,
                    title = "Outfit Preservation",
                    desc = "We capture every detail of your clothing—textures, colors, and logos—and map them perfectly."
                )
                FeatureItem(
                    icon = Icons.Default.Favorite,
                    title = "Topology Mapping",
                    desc = "Our AI adapts your likeness to any plushie shape while maintaining structural integrity."
                )
                FeatureItem(
                    icon = Icons.Default.Share,
                    title = "Save to Gallery",
                    desc = "Download your high-res plushie creation directly to your camera roll. Use it however and wherever you want."
                )
            }
        } else {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.Top
            ) {
                FeatureItem(
                    icon = Icons.Default.Face,
                    title = "Outfit Preservation",
                    desc = "We capture every detail of your clothing—textures, colors, and logos—and map them perfectly."
                )
                Spacer(modifier = Modifier.width(64.dp))
                FeatureItem(
                    icon = Icons.Default.Favorite,
                    title = "Topology Mapping",
                    desc = "Our AI adapts your likeness to any plushie shape while maintaining structural integrity."
                )
                Spacer(modifier = Modifier.width(64.dp))
                FeatureItem(
                    icon = Icons.Default.Share,
                    title = "Save to Gallery",
                    desc = "Download your high-res plushie creation directly to your camera roll. Use it however and wherever you want."
                )
            }
        }
    }
}

@Composable
fun FeatureItem(icon: ImageVector, title: String, desc: String) {
    Column(
        horizontalAlignment = Alignment.Start,
        modifier = Modifier.width(280.dp)
    ) {
        Icon(
            icon,
            contentDescription = null,
            tint = TextPrimary,
            modifier = Modifier.size(24.dp)
        )
        Spacer(modifier = Modifier.height(20.dp))
        Text(title, fontWeight = FontWeight.Bold, color = TextPrimary, fontSize = 18.sp)
        Spacer(modifier = Modifier.height(12.dp))
        Text(desc, textAlign = TextAlign.Start, color = TextSecondary, lineHeight = 24.sp, fontSize = 15.sp)
    }
}

@Composable
fun PricingSection(isMobile: Boolean) {
    val uriHandler = LocalUriHandler.current

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .background(BgWhite)
            .padding(vertical = if (isMobile) 60.dp else 120.dp, horizontal = 24.dp),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Text(
            "iOS In-App Purchases.",
            style = if (isMobile) MaterialTheme.typography.headlineMedium else MaterialTheme.typography.headlineLarge,
            fontWeight = FontWeight.Bold,
            color = TextPrimary,
            letterSpacing = (-1).sp,
            textAlign = TextAlign.Center
        )
        Spacer(modifier = Modifier.height(16.dp))
        Text(
            "Pay only for the compute units you need directly in the iOS app.",
            color = TextSecondary,
            fontSize = if (isMobile) 16.sp else 18.sp,
            textAlign = TextAlign.Center
        )
        Spacer(modifier = Modifier.height(64.dp))

        if (isMobile) {
            Column(
                modifier = Modifier.fillMaxWidth(),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(24.dp)
            ) {
                PricingCard(units = "300", price = "$0.99", isMobile = true)
                PricingCard(units = "1,600", price = "$4.99", isMobile = true)
                PricingCard(units = "5,200", price = "$14.99",  isMobile = true)
                PricingCard(units = "11,000", price = "$29.99", isMobile = true)
                PricingCard(units = "19,000", price = "$49.99", isMobile = true)
                PricingCard(units = "40,000", price = "$99.99", isMobile = true)
            }
        } else {
            // Use a grid-like layout for the pricing cards (2 rows of 3)
            Column {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.Center
                ) {
                    PricingCard(units = "300", price = "$0.99")
                    Spacer(modifier = Modifier.width(24.dp))
                    PricingCard(units = "1,600", price = "$4.99")
                    Spacer(modifier = Modifier.width(24.dp))
                    PricingCard(units = "5,200", price = "$14.99")
                }
                Spacer(modifier = Modifier.height(24.dp))
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.Center
                ) {
                    PricingCard(units = "11,000", price = "$29.99")
                    Spacer(modifier = Modifier.width(24.dp))
                    PricingCard(units = "19,000", price = "$49.99")
                    Spacer(modifier = Modifier.width(24.dp))
                    PricingCard(units = "40,000", price = "$99.99")
                }
            }
        }

        Spacer(modifier = Modifier.height(64.dp))

        // Enterprise Option
        Card(
            colors = CardDefaults.cardColors(containerColor = BgGray),
            elevation = CardDefaults.cardElevation(defaultElevation = 0.dp),
            modifier = Modifier
                .widthIn(max = 888.dp) // align with the grid width roughly
                .fillMaxWidth()
                .border(1.dp, BorderColor, RoundedCornerShape(12.dp)),
            shape = RoundedCornerShape(12.dp)
        ) {
            if (isMobile) {
                Column(
                    modifier = Modifier.padding(24.dp).fillMaxWidth(),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Text(
                        "Enterprise Solutions",
                        style = MaterialTheme.typography.titleLarge,
                        fontWeight = FontWeight.Bold,
                        color = TextPrimary,
                        textAlign = TextAlign.Center
                    )
                    Spacer(modifier = Modifier.height(16.dp))
                    Text(
                        "Looking to deploy our platform across your organization? We offer dedicated support, team management features, and custom enterprise solutions. Contact our support team at support@plushmorph.com to learn more.",
                        color = TextSecondary,
                        fontSize = 15.sp,
                        textAlign = TextAlign.Center
                    )
                    Spacer(modifier = Modifier.height(24.dp))
                    Button(
                        onClick = { uriHandler.openUri("mailto:support@plushmorph.com") },
                        colors = ButtonDefaults.buttonColors(containerColor = AccentBlack),
                        shape = RoundedCornerShape(8.dp),
                        contentPadding = PaddingValues(horizontal = 24.dp, vertical = 12.dp),
                        modifier = Modifier.fillMaxWidth()
                    ) {
                        Text("Contact Us", color = Color.White, fontWeight = FontWeight.SemiBold)
                    }
                }
            } else {
                Row(
                    modifier = Modifier.padding(40.dp).fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Column(modifier = Modifier.weight(1f).padding(end = 24.dp)) {
                        Text(
                            "Enterprise Solutions",
                            style = MaterialTheme.typography.titleLarge,
                            fontWeight = FontWeight.Bold,
                            color = TextPrimary
                        )
                        Spacer(modifier = Modifier.height(8.dp))
                        Text(
                            "Looking to deploy our platform across your organization? We offer dedicated support, team management features, and custom enterprise solutions. Contact our support team at support@plushmorph.com to learn more.",
                            color = TextSecondary,
                            fontSize = 15.sp
                        )
                    }
                    Button(
                        onClick = { uriHandler.openUri("mailto:support@plushmorph.com") },
                        colors = ButtonDefaults.buttonColors(containerColor = AccentBlack),
                        shape = RoundedCornerShape(8.dp),
                        contentPadding = PaddingValues(horizontal = 24.dp, vertical = 12.dp)
                    ) {
                        Text("Contact Us", color = Color.White, fontWeight = FontWeight.SemiBold)
                    }
                }
            }
        }
    }
}

@Composable
fun PricingCard(units: String, price: String, isMobile: Boolean = false) {
    Card(
        colors = CardDefaults.cardColors(containerColor = BgWhite),
        elevation = CardDefaults.cardElevation(defaultElevation = 0.dp),
        modifier = Modifier
            .then(if (isMobile) Modifier.fillMaxWidth() else Modifier.width(280.dp))
            .border(
                width = 1.dp,
                color = BorderColor,
                shape = RoundedCornerShape(20.dp)
            ),
        shape = RoundedCornerShape(20.dp)
    ) {
        Column(
            modifier = Modifier.padding(32.dp).fillMaxWidth(),
            horizontalAlignment = Alignment.Start
        ) {
            Text(
                units,
                style = MaterialTheme.typography.displaySmall,
                fontWeight = FontWeight.ExtraBold,
                color = TextPrimary,
                letterSpacing = (-1).sp
            )

            Text(
                "Compute Units",
                color = TextSecondary,
                fontSize = 14.sp,
                fontWeight = FontWeight.Medium
            )

            Spacer(modifier = Modifier.height(32.dp))
            HorizontalDivider(color = BorderColor)
            Spacer(modifier = Modifier.height(32.dp))

            Row(verticalAlignment = Alignment.Bottom) {
                Text(
                    price,
                    style = MaterialTheme.typography.headlineLarge,
                    fontWeight = FontWeight.Bold,
                    color = TextPrimary,
                    letterSpacing = (-0.5).sp
                )
                Text(
                    " / one-time",
                    color = TextSecondary.copy(alpha = 0.7f),
                    fontSize = 14.sp,
                    modifier = Modifier.padding(bottom = 6.dp, start = 4.dp)
                )
            }
        }
    }
}

@Composable
fun UseCasesSection(isMobile: Boolean) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .background(BgGray)
            .padding(vertical = if (isMobile) 60.dp else 120.dp, horizontal = 24.dp),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Text(
            "What can you build?",
            style = if (isMobile) MaterialTheme.typography.headlineSmall else MaterialTheme.typography.headlineMedium,
            fontWeight = FontWeight.Bold,
            color = TextPrimary
        )
        Spacer(modifier = Modifier.height(64.dp))
        if (isMobile) {
            Column(
                modifier = Modifier.fillMaxWidth(),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(24.dp)
            ) {
                UseCaseCard(
                    icon = Icons.Default.Face,
                    title = "Unique Social Avatars",
                    description = "Stand out on Twitter, Instagram, or Discord. Replace generic photos with a high-fidelity plushie version of yourself that keeps your personal style.",
                    isMobile = true
                )
                UseCaseCard(
                    icon = Icons.Default.Star,
                    title = "Build Your Mini-Me Gallery",
                    description = "Collect different versions of yourself. From classic teddy bears to exotic plushie shapes, see how your favorite outfits look in every form.",
                    isMobile = true
                )
                UseCaseCard(
                    icon = Icons.Default.Share,
                    title = "Privacy-First Selfies",
                    description = "Want to show off your fit without showing your face? Morph your photo before posting. Keep the drip, protect your privacy.",
                    isMobile = true
                )
            }
        } else {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.Top
            ) {
                UseCaseCard(
                    icon = Icons.Default.Face,
                    title = "Unique Social Avatars",
                    description = "Stand out on Twitter, Instagram, or Discord. Replace generic photos with a high-fidelity plushie version of yourself that keeps your personal style."
                )
                Spacer(modifier = Modifier.width(24.dp))
                UseCaseCard(
                    icon = Icons.Default.Star,
                    title = "Build Your Mini-Me Gallery",
                    description = "Collect different versions of yourself. From classic teddy bears to exotic plushie shapes, see how your favorite outfits look in every form."
                )
                Spacer(modifier = Modifier.width(24.dp))
                UseCaseCard(
                    icon = Icons.Default.Share,
                    title = "Privacy-First Selfies",
                    description = "Want to show off your fit without showing your face? Morph your photo before posting. Keep the drip, protect your privacy."
                )
            }
        }
    }
}

@Composable
fun UseCaseCard(icon: ImageVector, title: String, description: String, isMobile: Boolean = false) {
    Card(
        colors = CardDefaults.cardColors(containerColor = BgWhite),
        elevation = CardDefaults.cardElevation(defaultElevation = 0.dp),
        modifier = Modifier.then(if (isMobile) Modifier.fillMaxWidth() else Modifier.width(420.dp)).border(1.dp, BorderColor, RoundedCornerShape(12.dp)),
        shape = RoundedCornerShape(12.dp)
    ) {
        Column(modifier = Modifier.padding(32.dp)) {
            Icon(
                icon,
                contentDescription = null,
                tint = AccentBlack,
                modifier = Modifier.size(32.dp)
            )
            Spacer(modifier = Modifier.height(24.dp))
            Text(
                title,
                fontWeight = FontWeight.Bold,
                fontSize = 20.sp,
                color = TextPrimary
            )
            Spacer(modifier = Modifier.height(12.dp))
            Text(
                description,
                style = MaterialTheme.typography.bodyLarge,
                color = TextSecondary,
                lineHeight = 28.sp,
                fontSize = 16.sp
            )
        }
    }
}

@Composable
fun FAQSection(isMobile: Boolean) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(vertical = if (isMobile) 60.dp else 120.dp, horizontal = 24.dp),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Text(
            "Frequently Asked Questions",
            style = if (isMobile) MaterialTheme.typography.headlineMedium else MaterialTheme.typography.headlineLarge,
            fontWeight = FontWeight.Bold,
            color = TextPrimary,
            letterSpacing = (-1).sp,
            textAlign = TextAlign.Center
        )
        Spacer(modifier = Modifier.height(64.dp))
        Column(
            modifier = Modifier.widthIn(max = 800.dp)
        ) {
            FAQItem(
                question = "How does PlushMorph work?",
                answer = "We use advanced AI models to analyze your uploaded photo, capturing details like your facial features and clothing, and seamlessly map them onto a plushie topology."
            )
            HorizontalDivider(color = BorderColor, modifier = Modifier.padding(vertical = 24.dp))
            FAQItem(
                question = "Are my photos private and secure?",
                answer = "Absolutely. Your photos are encrypted in transit and temporarily processed on secure cloud servers. All uploaded images and processing data are automatically expunged within 24 hours. We never use your photos to train AI models."
            )
            HorizontalDivider(color = BorderColor, modifier = Modifier.padding(vertical = 24.dp))
            FAQItem(
                question = "How do Compute Units work?",
                answer = "PlushMorph uses Compute Units to perform AI generation. You can purchase these securely via Apple In-App Purchases. Once acquired, your units never expire as long as your account remains active."
            )
            HorizontalDivider(color = BorderColor, modifier = Modifier.padding(vertical = 24.dp))
            FAQItem(
                question = "Need help or have questions?",
                answer = "We're here to help! If you encounter any issues, have questions about your account, or want to provide feedback, please reach out to our dedicated support team at support@plushmorph.com. We're committed to reviewing all inquiries and responding within 24 hours."
            )
        }
    }
}

@Composable
fun FAQItem(question: String, answer: String) {
    Column(modifier = Modifier.fillMaxWidth()) {
        Text(
            question,
            style = MaterialTheme.typography.titleLarge,
            fontWeight = FontWeight.Bold,
            color = TextPrimary
        )
        Spacer(modifier = Modifier.height(12.dp))
        Text(
            answer,
            style = MaterialTheme.typography.bodyLarge,
            color = TextSecondary,
            lineHeight = 26.sp
        )
    }
}

@Composable
fun Footer() {
    val uriHandler = LocalUriHandler.current
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 24.dp, vertical = 80.dp),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            Image(
                painter = painterResource(Res.drawable.app_icon),
                contentDescription = "Logo",
                modifier = Modifier.size(20.dp).clip(RoundedCornerShape(4.dp))
            )
            Spacer(modifier = Modifier.width(8.dp))
            Text("PlushMorph", color = TextPrimary, fontWeight = FontWeight.Bold, fontSize = 14.sp)
        }
        Spacer(modifier = Modifier.height(32.dp))
        Row {
            Text("Terms", color = TextSecondary, fontSize = 14.sp, modifier = Modifier.clickable { uriHandler.openUri("/term") })
            Spacer(modifier = Modifier.width(32.dp))
            Text("Privacy", color = TextSecondary, fontSize = 14.sp, modifier = Modifier.clickable { uriHandler.openUri("/privacy") })
        }
        Spacer(modifier = Modifier.height(64.dp))
    }
}

//package org.example.project
//
//import androidx.compose.foundation.Image
//import androidx.compose.foundation.background
//import androidx.compose.foundation.border
//import androidx.compose.foundation.clickable
//import androidx.compose.foundation.layout.Arrangement
//import androidx.compose.foundation.layout.Box
//import androidx.compose.foundation.layout.Column
//import androidx.compose.foundation.layout.PaddingValues
//import androidx.compose.foundation.layout.Row
//import androidx.compose.foundation.layout.Spacer
//import androidx.compose.foundation.layout.fillMaxWidth
//import androidx.compose.foundation.layout.height
//import androidx.compose.foundation.layout.padding
//import androidx.compose.foundation.layout.size
//import androidx.compose.foundation.layout.width
//import androidx.compose.foundation.layout.widthIn
//import androidx.compose.foundation.shape.RoundedCornerShape
//import androidx.compose.material.icons.Icons
//import androidx.compose.material.icons.automirrored.filled.ExitToApp
//import androidx.compose.material.icons.filled.Add
//import androidx.compose.material.icons.filled.CheckCircle
//import androidx.compose.material.icons.filled.Refresh
//import androidx.compose.material.icons.filled.Settings
//import androidx.compose.material.icons.filled.Star
//import androidx.compose.material3.Button
//import androidx.compose.material3.ButtonDefaults
//import androidx.compose.material3.Card
//import androidx.compose.material3.CardDefaults
//import androidx.compose.material3.DropdownMenu
//import androidx.compose.material3.DropdownMenuItem
//import androidx.compose.material3.ExperimentalMaterial3Api
//import androidx.compose.material3.HorizontalDivider
//import androidx.compose.material3.Icon
//import androidx.compose.material3.LinearProgressIndicator
//import androidx.compose.material3.MaterialTheme
//import androidx.compose.material3.Text
//import androidx.compose.material3.TextButton
//import androidx.compose.material3.TopAppBar
//import androidx.compose.material3.TopAppBarDefaults
//import androidx.compose.runtime.Composable
//import androidx.compose.runtime.LaunchedEffect
//import androidx.compose.runtime.getValue
//import androidx.compose.runtime.mutableStateOf
//import androidx.compose.runtime.remember
//import androidx.compose.runtime.setValue
//import androidx.compose.ui.Alignment
//import androidx.compose.ui.Modifier
//import androidx.compose.ui.draw.clip
//import androidx.compose.ui.draw.shadow
//import androidx.compose.ui.graphics.Color
//import androidx.compose.ui.text.font.FontWeight
//import androidx.compose.ui.text.style.TextAlign
//import androidx.compose.ui.unit.dp
//import androidx.compose.ui.unit.sp
//import kotlinx.coroutines.delay
//import org.jetbrains.compose.resources.painterResource
//import plush_morph_partner.composeapp.generated.resources.AppIcon
//import plush_morph_partner.composeapp.generated.resources.Res
//
//
//@OptIn(ExperimentalMaterial3Api::class)
//@Composable
//fun Header(
//    isLoggedIn: Boolean = false,
//    userEmail: String? = null,
//    onLoginClick: () -> Unit = {},
//    onLogoutClick: () -> Unit = {},
//    onSettingsClick: () -> Unit = {}
//) {
//    TopAppBar(
//        title = {
//            Row(
//                verticalAlignment = Alignment.CenterVertically // 让图片和文字垂直居中对齐
//            ) {
//                // 1. 显示图片
//                Image(
//                    painter = painterResource(Res.drawable.AppIcon), // 这里的 logo 对应你的文件名
//                    contentDescription = "PlushMorph Logo",
//                    modifier = Modifier.size(32.dp), // 限制一下图片大小，不要太大
//                )
//
//                // 2. 加一点间距
//                Spacer(modifier = Modifier.width(12.dp))
//
//                // 3. 原来的文字
//                Text(
//                    "PlushMorph",
//                    fontWeight = FontWeight.Bold,
//                    color = MaterialTheme.colorScheme.primary
//                )
//            }
//        },
//        actions = {
//            if (isLoggedIn) {
//                var showMenu by remember { mutableStateOf(false) }
//                val avatarText = userEmail?.take(2)?.uppercase() ?: "JD"
//
//                Box {
//                    // User Avatar with click to toggle menu
//                    Box(
//                        modifier = Modifier
//                            .size(36.dp)
//                            .clip(RoundedCornerShape(50))
//                            .background(AccentColor)
//                            .clickable { showMenu = true },
//                        contentAlignment = Alignment.Center
//                    ) {
//                        Text(avatarText, color = Color.White, fontWeight = FontWeight.Bold)
//                    }
//
//                    DropdownMenu(
//                        expanded = showMenu,
//                        onDismissRequest = { showMenu = false },
//                        modifier = Modifier.background(Color.White)
//                    ) {
//                        if (userEmail != null) {
//                            DropdownMenuItem(
//                                text = {
//                                    Column {
//                                        Text(
//                                            "Signed in as",
//                                            style = MaterialTheme.typography.labelSmall,
//                                            color = Color.Gray
//                                        )
//                                        Text(
//                                            userEmail,
//                                            fontWeight = FontWeight.Bold,
//                                            style = MaterialTheme.typography.bodyMedium
//                                        )
//                                    }
//                                },
//                                onClick = {},
//                                enabled = false // Make it non-clickable effectively acting as a header
//                            )
//                            HorizontalDivider()
//                        }
//
//                        DropdownMenuItem(
//                            text = { Text("Settings") },
//                            onClick = {
//                                showMenu = false
//                                onSettingsClick()
//                            },
//                            leadingIcon = { Icon(Icons.Default.Settings, contentDescription = null) }
//                        )
//
//                        DropdownMenuItem(
//                            text = { Text("Log Out") },
//                            onClick = {
//                                showMenu = false
//                                onLogoutClick()
//                            },
//                            leadingIcon = { Icon(Icons.AutoMirrored.Filled.ExitToApp, contentDescription = null) }
//                        )
//                    }
//                }
//                Spacer(modifier = Modifier.width(16.dp))
//            } else {
//                Button(
//                    onClick = onLoginClick,
//                    colors = ButtonDefaults.buttonColors(containerColor = PrimaryColor),
//                    contentPadding = PaddingValues(horizontal = 20.dp)
//                ) {
//                    Text("Get Started")
//                }
//                Spacer(modifier = Modifier.width(16.dp))
//            }
//        },
//        colors = TopAppBarDefaults.topAppBarColors(
//            containerColor = Color.White.copy(alpha = 0.9f)
//        ),
//        modifier = Modifier.shadow(elevation = 1.dp)
//    )
//}
//
//@Composable
//fun TrustedBySection() {
//    Column(
//        modifier = Modifier
//            .fillMaxWidth()
//            .padding(vertical = 32.dp)
//            .background(Color(0xFFF1F5F9)),
//        horizontalAlignment = Alignment.CenterHorizontally
//    ) {
//        Text(
//            "TRUSTED BY INNOVATIVE TEAMS AT",
//            style = MaterialTheme.typography.labelMedium,
//            fontWeight = FontWeight.Bold,
//            color = Color.Gray,
//            letterSpacing = 1.5.sp
//        )
//        Spacer(modifier = Modifier.height(24.dp))
//        Row(
//            modifier = Modifier.fillMaxWidth(),
//            horizontalArrangement = Arrangement.Center,
//            verticalAlignment = Alignment.CenterVertically
//        ) {
//            listOf("ACME CORP", "GLOBALTECH", "NEBULA AI", "VERTEX STRAT", "OASIS SYSTEMS").forEach { name ->
//                Text(
//                    name,
//                    style = MaterialTheme.typography.titleMedium,
//                    fontWeight = FontWeight.Bold,
//                    color = Color.Gray.copy(alpha = 0.5f),
//                    modifier = Modifier.padding(horizontal = 24.dp)
//                )
//            }
//        }
//    }
//}
//
//@Composable
//fun HeroSection() {
//    Column(
//        modifier = Modifier
//            .fillMaxWidth()
//            .padding(vertical = 80.dp, horizontal = 24.dp),
//        horizontalAlignment = Alignment.CenterHorizontally
//    ) {
//        Text(
//            "The Future of Visual Synthesis",
//            style = MaterialTheme.typography.displayMedium,
//            fontWeight = FontWeight.ExtraBold,
//            textAlign = TextAlign.Center,
//            color = MaterialTheme.colorScheme.primary
//        )
//        Spacer(modifier = Modifier.height(24.dp))
//        Text(
//            "Enterprise-grade image merging technology for the modern web.\nReliable. Scalable. Secure.",
//            style = MaterialTheme.typography.titleLarge,
//            textAlign = TextAlign.Center,
//            color = Color.Gray
//        )
//        Spacer(modifier = Modifier.height(40.dp))
//        Button(
//            onClick = { /* TODO: Scroll to demo */ },
//            colors = ButtonDefaults.buttonColors(
//                containerColor = MaterialTheme.colorScheme.primary
//            ),
//            modifier = Modifier.height(50.dp)
//        ) {
//            Text("Try the Demo", fontSize = 18.sp)
//        }
//    }
//}
//
//@Composable
//fun FeaturesSection() {
//    Row(
//        modifier = Modifier
//            .fillMaxWidth()
//            .padding(vertical = 40.dp, horizontal = 24.dp),
//        horizontalArrangement = Arrangement.Center,
//        verticalAlignment = Alignment.CenterVertically
//    ) {
//        // In a real responsive web setup we'd wrap these, but for now a simple Row/Column fallback or just simple layout
//        FeatureItem("Security First", "SOC2 Compliant Architecture")
//        Spacer(modifier = Modifier.width(24.dp))
//        FeatureItem("High Fidelity", "Lossless Neural Rendering")
//        Spacer(modifier = Modifier.width(24.dp))
//        FeatureItem("99.9% Uptime", "Distributed Global Edge")
//    }
//}
//
//@Composable
//fun FeatureItem(title: String, desc: String) {
//    Column(
//        horizontalAlignment = Alignment.CenterHorizontally,
//        modifier = Modifier
//            .padding(16.dp)
//            .width(200.dp)
//    ) {
//        Icon(
//            Icons.Default.CheckCircle,
//            contentDescription = null,
//            tint = MaterialTheme.colorScheme.secondary,
//            modifier = Modifier.size(48.dp)
//        )
//        Spacer(modifier = Modifier.height(16.dp))
//        Text(title, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleMedium)
//        Text(desc, textAlign = TextAlign.Center, style = MaterialTheme.typography.bodyMedium, color = Color.Gray)
//    }
//}
//
//@Composable
//fun TechnologySection() {
//    Column(
//        modifier = Modifier
//            .fillMaxWidth()
//            .background(PrimaryColor)
//            .padding(vertical = 80.dp, horizontal = 24.dp),
//        horizontalAlignment = Alignment.CenterHorizontally
//    ) {
//        Text(
//            "Powered by Neural Morphing™",
//            style = MaterialTheme.typography.displaySmall,
//            fontWeight = FontWeight.Bold,
//            color = Color.White
//        )
//        Spacer(modifier = Modifier.height(24.dp))
//        Text(
//            "Our proprietary Generative Adversarial Network (GAN) architecture ensures pixel-perfect synthesis. \nBy leveraging latent space interpolation, we achieve zero-artifact blending at scale.",
//            style = MaterialTheme.typography.bodyLarge,
//            textAlign = TextAlign.Center,
//            color = Color.White.copy(alpha = 0.8f),
//            modifier = Modifier.widthIn(max = 800.dp)
//        )
//    }
//}
//
//@Composable
//fun TestimonialsSection() {
//    Column(
//        modifier = Modifier
//            .fillMaxWidth()
//            .padding(vertical = 80.dp, horizontal = 24.dp),
//        horizontalAlignment = Alignment.CenterHorizontally
//    ) {
//        Text(
//            "Backed by Industry Leaders",
//            style = MaterialTheme.typography.headlineMedium,
//            fontWeight = FontWeight.Bold,
//            color = MaterialTheme.colorScheme.primary
//        )
//        Spacer(modifier = Modifier.height(48.dp))
//        Row(
//            modifier = Modifier.fillMaxWidth(),
//            horizontalArrangement = Arrangement.Center,
//            verticalAlignment = Alignment.Top
//        ) {
//            TestimonialCard(
//                "\"PlushMorph is redefining the visual stack. The reliability and speed are unmatched.\"",
//                "Sarah Chen",
//                "Partner, Sequoia Capital"
//            )
//            Spacer(modifier = Modifier.width(32.dp))
//            TestimonialCard(
//                "\"Finally, an enterprise-ready solution for generative image synthesis. A game changer.\"",
//                "Mike Ross",
//                "CTO, TechGiant Inc."
//            )
//        }
//    }
//}
//
//@Composable
//fun TestimonialCard(quote: String, author: String, role: String) {
//    Card(
//        colors = CardDefaults.cardColors(containerColor = Color.White),
//        elevation = CardDefaults.cardElevation(defaultElevation = 2.dp),
//        modifier = Modifier.width(350.dp)
//    ) {
//        Column(modifier = Modifier.padding(24.dp)) {
//            Row {
//                repeat(5) {
//                    Icon(
//                        Icons.Default.Star,
//                        contentDescription = null,
//                        tint = Color(0xFFFFC107), // Amber 500
//                        modifier = Modifier.size(20.dp)
//                    )
//                }
//            }
//            Spacer(modifier = Modifier.height(16.dp))
//            Text(
//                quote,
//                style = MaterialTheme.typography.bodyLarge,
//                fontStyle = androidx.compose.ui.text.font.FontStyle.Italic
//            )
//            Spacer(modifier = Modifier.height(24.dp))
//            Text(author, fontWeight = FontWeight.Bold)
//            Text(role, style = MaterialTheme.typography.bodySmall, color = Color.Gray)
//        }
//    }
//}
//
//@Composable
//fun DemoSection() {
//    var image1Selected by remember { mutableStateOf(false) }
//    var image2Selected by remember { mutableStateOf(false) }
//    var isProcessing by remember { mutableStateOf(false) }
//    var isSuccess by remember { mutableStateOf(false) }
//    var progress by remember { mutableStateOf(0f) }
//
//    LaunchedEffect(isProcessing) {
//        if (isProcessing) {
//            val steps = 100
//            for (i in 1..steps) {
//                progress = i / 100f
//                delay(20) // Simulate work
//            }
//            isProcessing = false
//            isSuccess = true
//        }
//    }
//
//    Column(
//        modifier = Modifier
//            .fillMaxWidth()
//            .padding(60.dp)
//            .background(Color.White, shape = RoundedCornerShape(16.dp))
//            .border(1.dp, Color.LightGray.copy(alpha = 0.5f), RoundedCornerShape(16.dp))
//            .padding(40.dp),
//        horizontalAlignment = Alignment.CenterHorizontally
//    ) {
//        Text(
//            "Interactive Demo",
//            style = MaterialTheme.typography.headlineMedium,
//            fontWeight = FontWeight.Bold,
//            modifier = Modifier.padding(bottom = 32.dp)
//        )
//
//        if (!isSuccess) {
//            Row(
//                modifier = Modifier.fillMaxWidth(),
//                horizontalArrangement = Arrangement.SpaceEvenly,
//                verticalAlignment = Alignment.CenterVertically
//            ) {
//                UploadBox("Image A", image1Selected) { image1Selected = true }
//                Text("+", fontSize = 32.sp, color = Color.Gray)
//                UploadBox("Image B", image2Selected) { image2Selected = true }
//            }
//
//            Spacer(modifier = Modifier.height(40.dp))
//
//            if (isProcessing) {
//                Column(horizontalAlignment = Alignment.CenterHorizontally, modifier = Modifier.fillMaxWidth(0.6f)) {
//                    LinearProgressIndicator(
//                        progress = { progress },
//                        modifier = Modifier.fillMaxWidth().height(8.dp),
//                        color = MaterialTheme.colorScheme.secondary,
//                        trackColor = Color(0xFFE2E8F0),
//                    )
//                    Spacer(modifier = Modifier.height(16.dp))
//                    Text("Processing Neural Layers... ${(progress * 100).toInt()}%", color = Color.Gray)
//                }
//            } else {
//                Button(
//                    onClick = { isProcessing = true },
//                    enabled = image1Selected && image2Selected,
//                    modifier = Modifier
//                        .fillMaxWidth(0.5f)
//                        .height(56.dp),
//                    shape = RoundedCornerShape(8.dp)
//                ) {
//                    Text("Generate Merge")
//                }
//            }
//        } else {
//            // Success State
//            Column(horizontalAlignment = Alignment.CenterHorizontally) {
//                Icon(
//                    Icons.Default.CheckCircle,
//                    contentDescription = null,
//                    tint = Color(0xFF10B981), // Emerald 500
//                    modifier = Modifier.size(64.dp)
//                )
//                Spacer(modifier = Modifier.height(16.dp))
//                Text("Merge Complete!", style = MaterialTheme.typography.titleLarge, fontWeight = FontWeight.Bold)
//                Spacer(modifier = Modifier.height(24.dp))
//
//                // Result Placeholder
//                Box(
//                    modifier = Modifier
//                        .size(300.dp)
//                        .background(Color(0xFFE2E8F0))
//                        .border(1.dp, Color.Gray, RoundedCornerShape(8.dp)),
//                    contentAlignment = Alignment.Center
//                ) {
//                    Text("Synthesized Result", color = Color.Gray)
//                }
//
//                Spacer(modifier = Modifier.height(32.dp))
//                Button(
//                    onClick = {
//                        isSuccess = false
//                        image1Selected = false
//                        image2Selected = false
//                        progress = 0f
//                    },
//                    colors = ButtonDefaults.buttonColors(containerColor = Color.Gray)
//                ) {
//                    Icon(Icons.Default.Refresh, contentDescription = null, modifier = Modifier.size(16.dp))
//                    Spacer(modifier = Modifier.width(8.dp))
//                    Text("Start Over")
//                }
//            }
//        }
//    }
//}
//
//@Composable
//fun UploadBox(label: String, isSelected: Boolean, onClick: () -> Unit) {
//    Box(
//        modifier = Modifier
//            .size(200.dp)
//            .clip(RoundedCornerShape(12.dp))
//            .background(if (isSelected) Color(0xFFEFF6FF) else Color(0xFFF1F5F9))
//            .border(
//                width = 2.dp,
//                color = if (isSelected) MaterialTheme.colorScheme.secondary else Color.Transparent,
//                shape = RoundedCornerShape(12.dp)
//            )
//            .clickable { onClick() },
//        contentAlignment = Alignment.Center
//    ) {
//        Column(horizontalAlignment = Alignment.CenterHorizontally) {
//            if (isSelected) {
//                Icon(
//                    Icons.Default.CheckCircle,
//                    contentDescription = "Selected",
//                    tint = MaterialTheme.colorScheme.secondary,
//                    modifier = Modifier.size(40.dp)
//                )
//                Spacer(modifier = Modifier.height(8.dp))
//                Text(label, fontWeight = FontWeight.SemiBold, color = MaterialTheme.colorScheme.secondary)
//            } else {
//                Icon(
//                    Icons.Default.Add,
//                    contentDescription = "Upload",
//                    tint = Color.Gray,
//                    modifier = Modifier.size(40.dp)
//                )
//                Spacer(modifier = Modifier.height(8.dp))
//                Text("Upload $label", color = Color.Gray)
//            }
//        }
//    }
//}
//
//@Composable
//fun Footer() {
//    val uriHandler = androidx.compose.ui.platform.LocalUriHandler.current
//
//    Column(
//        modifier = Modifier
//            .fillMaxWidth()
//            .background(PrimaryColor)
//            .padding(32.dp),
//        horizontalAlignment = Alignment.CenterHorizontally
//    ) {
//        Text(
//            "© 2026 PlushMorph Inc. All rights reserved.",
//            color = Color.White.copy(alpha = 0.6f),
//            style = MaterialTheme.typography.labelMedium
//        )
//    }
//}